import { Page, Document, StyleSheet, Text, View } from "@react-pdf/renderer";
import Footer from "./Footer";
import Header from "./Header";

const primaryColor = "#3778C2";
const lightGray = "#F3F6FA";

const styles = StyleSheet.create({
      page: {
    backgroundColor: "#fff",
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 40,
    paddingRight: 40,
    lineHeight: 1.5,
    flexDirection: "column",
  },
  title: {
    fontSize: 26,
    color: primaryColor,
    textAlign: "center",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginBottom: 5,
  },
  subtitle: {
    textAlign: "center",
    fontSize: 12,
    color: "#666",
    marginBottom: 20,
         marginTop: 10,
  },
  sectionHeader: {
    backgroundColor: primaryColor,
    color: "#fff",
    fontWeight: "bold",
    fontSize: 13,
    padding: 6,
    borderRadius: 3,
    marginTop: 20,
    marginBottom: 8,
  },
  infoRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
  },
  infoLabel: {
    color: "#222",
    fontWeight: "bold",
  },
  infoValue: {
    color: "#444",
  },
  tableContainer: {
    borderWidth: 1,
    borderColor: primaryColor,
    borderRadius: 3,
    marginTop: 10,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: primaryColor,
    color: "#fff",
    fontWeight: "bold",
    textAlign: "center",
  },
  headerTitle: {
    width: "30%",
    padding: 6,
    fontSize: 11,
    borderRightWidth: 1,
    borderRightColor: "#fff",
  },
  headerDesc: {
    width: "70%",
    padding: 6,
    fontSize: 11,
  },
  row: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#E5E5E5",
  },
  cellTitle: {
    width: "30%",
    padding: 6,
    backgroundColor: lightGray,
    borderRightWidth: 1,
    borderRightColor: "#E5E5E5",
    color: "#333",
    fontWeight: "bold",
    fontSize: 10.5,
  },
  cellDesc: {
    width: "70%",
    padding: 6,
    fontSize: 10.5,
    color: "#444",
  },
});

const Corporate = ({ pdfData }) => {
    return (
        <Document>
            <Page size="A4" style={styles.page}>


                {/* Title */}
                <Text style={styles.title}>Corporate Quotation</Text>
                <Text style={styles.subtitle}>
                    Professional solutions for your corporate events
                </Text>
                {/* Header */}
                <Header />
                {/* Client Info */}
                <Text style={styles.sectionHeader}>Client Information</Text>
                <View style={styles.infoRow}>
                    <Text style={styles.infoLabel}>Contact Person:</Text>
                    <Text style={styles.infoValue}>{pdfData?.name || "N/A"}</Text>
                </View>
                <View style={styles.infoRow}>
                    <Text style={styles.infoLabel}>Mobile Number:</Text>
                    <Text style={styles.infoValue}>{pdfData?.mob_no || "N/A"}</Text>
                </View>
                {pdfData?.preferred_location?.label && (
                    <View style={styles.infoRow}>
                        <Text style={styles.infoLabel}>Location:</Text>
                        <Text style={styles.infoValue}>
                            {pdfData?.preferred_location?.label || "N/A"}
                        </Text>
                    </View>
                )}
                <View style={styles.infoRow}>
                    <Text style={styles.infoLabel}>Event Date:</Text>
                    <Text style={styles.infoValue}>{pdfData?.event_date || "N/A"}</Text>
                </View>
                <View style={styles.infoRow}>
                    <Text style={styles.infoLabel}>Event Budget:</Text>
                    <Text style={styles.infoValue}>{pdfData?.event_budget || "N/A"}</Text>
                </View>

                {/* Details Table */}
                <View style={styles.tableContainer}>
                    <View style={styles.tableHeader}>
                        <Text style={styles.headerTitle}>Title</Text>
                        <Text style={styles.headerDesc}>Description</Text>
                    </View>

                    <View style={styles.row}>
                        <Text style={styles.cellTitle}>Event Type</Text>
                        <Text style={styles.cellDesc}>
                            {pdfData?.event_options
                                ?.filter((item) => item.isSelected)
                                .map((item) => item.name)
                                .join(", ") || "N/A"}
                        </Text>
                    </View>

                    <View style={styles.row}>
                        <Text style={styles.cellTitle}>Food Type</Text>
                        <Text style={styles.cellDesc}>{pdfData?.food_type || "N/A"}</Text>
                    </View>

                    <View style={styles.row}>
                        <Text style={styles.cellTitle}>Menu Price</Text>
                        <Text style={styles.cellDesc}>{pdfData?.menu_price || "N/A"}</Text>
                    </View>

                    <View style={styles.row}>
                        <Text style={styles.cellTitle}>Number of Rooms</Text>
                        <Text style={styles.cellDesc}>{pdfData?.no_of_room || "N/A"}</Text>
                    </View>

                    <View style={styles.row}>
                        <Text style={styles.cellTitle}>Number of Guests</Text>
                        <Text style={styles.cellDesc}>{pdfData?.no_of_guest || "N/A"}</Text>
                    </View>
{/* 
                    <View style={styles.row}>
                        <Text style={styles.cellTitle}>Photography Service</Text>
                        <Text style={styles.cellDesc}>
                            {pdfData?.photographer_options
                                ?.filter((item) => item.isSelected)
                                .map((item) => item.name)
                                .join(", ") || "N/A"}
                        </Text>
                    </View> */}

                    <View style={styles.row}>
                        <Text style={styles.cellTitle}>Additional Requirements</Text>
                        <Text style={styles.cellDesc}>
                            {pdfData?.service_option
                                ?.filter((item) => item.isSelected)
                                .map((item) => item.name)
                                .join(", ") || "N/A"}
                        </Text>
                    </View>

                    <View style={styles.row}>
                        <Text style={styles.cellTitle}>Venue Type</Text>
                        <Text style={styles.cellDesc}>
                            {pdfData?.venue_options
                                ?.filter((item) => item.isSelected)
                                .map((item) => item.name)
                                .join(", ") || "N/A"}
                        </Text>
                    </View>

                    {pdfData?.notes && (
                        <View style={styles.row}>
                            <Text style={styles.cellTitle}>Notes</Text>
                            <Text style={styles.cellDesc}>{pdfData?.notes}</Text>
                        </View>
                    )}
                </View>

                {/* Footer */}
                <Footer />
            </Page>
        </Document>
    );
};

export default Corporate;